<template>
  <!--<div class="page" :class="windowResize==1?'windowW':''" v-wechat-title="$route.meta.title">-->
  <div class="page" :class="[bodyHide==1?'border-box overflow':'', shopid=='1603'||shopid=='1810'?'page-yn':'',newStyle?'bf':'' ]" v-wechat-title="$route.meta.title">

    <!--原本样式-->
    <div class="main-scroll-view main-scroll-view1" style="position: relative; width: 100%; height: auto;" v-if="!newStyle">
      <img class="video_play_bg" src="../../assets/video-bg.jpg" alt="">

      <!--顶部视频信息-->
      <div class="list border-box">
        <!--<div class="list-box box border-box">-->
        <!--<div class="block list-img" id="list-img">-->
        <!--<img class="img list-video-img" v-lazy="bagInfo.tvideourl" alt="" v-if="bagInfo.vrimg==''||bagInfo.vrimg==null">-->
        <!--</div>-->
        <!--</div>-->

        <div class="list-box box border-box">
          <div class="block list-img">
            <img class="img icon-tx" :src="bagInfo.guideheadimg2?bagInfo.guideheadimg2:bagInfo.guideheadimg" alt="" @click="goGuideInfo(id)">
          </div>

          <div class="block flex list-info">
            <!--语音名称-->
            <p class="list-group hide">
              <span class="fl hide" style="width: 100%;">{{bagInfo.name}}</span>
            </p>

            <p class="list-name hide">
              {{bagInfo.guidename2?bagInfo.guidename2:bagInfo.guidename}}
              <span v-if="bagInfo.guidetag">/{{bagInfo.guidetag?bagInfo.guidetag:''}}</span>
            </p>


            <!--新增星级评分-->
            <div class="star-box-new clearfix">
              <img :src="(bagInfo.hotlevel>=2)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
              <img :src="(bagInfo.hotlevel>=4)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
              <img :src="(bagInfo.hotlevel>=6)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
              <img :src="(bagInfo.hotlevel>=8)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
              <img :src="(bagInfo.hotlevel>=10)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
              <span>{{bagInfo.hotlevel}}分</span>
            </div>
          </div>
        </div>

        <div v-if="bagInfo.guideinfo && bagInfo.guideinfo.length>0" class="list-box-info" :class="guideInfoState==0 && bagInfo.guideinfo && bagInfo.guideinfo.length>60?'hide2':''" @click="guideInfoStateFun">{{bagInfo.guideinfo}}</div>


        <div class="list-video-con border-box">
          <!--<div class="list-video-name hide">{{bagInfo.name}}</div>-->
          <div class="list-time-num clearfix">
            <p class="fl" v-if="bagInfo.listen>=0">
              <img src="../../assets/adot-5.png" />
              {{bagInfo.listen|initNumber}}次播放
            </p>
            <p class="fl" v-if="(bagInfo.dsnum>=0&&bagInfo.buynum<=0&&res.noReward!=1)|| noBuys.indexOf(shopid)>-1">
              <img src="../../assets/adot-3.png" />
              {{bagInfo.dsnum|initNumber}}人打赏
            </p>
            <p class="fl" v-else-if="(bagInfo.buynum>0&&bagInfo.price>=0) && noBuys.indexOf(shopid)<=-1">
              <img src="../../assets/adot-3.png" />
              {{bagInfo.buynum|initNumber1}}人购买
            </p>

            <div class="list-share" @click="showPoster">
              <img src="../../assets/icon-share-btn.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <!--新增打赏-->
      <div class="ds-box border-box" @click="rewardShowFun" v-if="res.noReward!=1">
        <div v-if="res.dsimgs && res.dsimgs.length>0">
          <img v-for="(item,index) in res.dsimgs"  class="img ds-box-img" v-lazy="item.rzimg?item.rzimg:item.img"/>
          <span class="ds-box-num">已有{{bagInfo.dsnum}}人打赏</span>
        </div>
        <div v-if="!res.dsimgs||res.dsimgs.length==0">
          <span class="ds-box-num">暂无打赏</span>
        </div>
        <span class="fr ds-box-btn">打赏</span>
      </div>


      <p class="split-line" style="margin-top: .34rem;height: .02rem;background: #f1f1f1;"></p>


      <!--新增标题-->
      <div class="list-tit-new border-box clearfix">
        <span>全景景点解说</span>
        <span>包含{{bagInfo.sees}}个讲解点</span>
      </div>

      <div style="position: relative;">
        <div v-for="(item,index) in voice" :key="index" class="video-list border-box clearfix">
          <p class="list-title">
            <img class="icon_gps" src="../../assets/icon_gps1.png" />
            {{item.pspotname}}
          </p>

          <div v-for="(ite,ind) in item.list" :key="ind" class="video-list-info" :id="'video-list-spotid'+ite.spotid">
            <div class="video-list-con border-box" :class="(ite.number==switchScneNumber)?'curr':''" @click="openVR(ite.number)">
              <span class="list-video-mask"></span>
              <img class="icon_360" src="../../assets/icon_360.png" alt="">
              <img class="img video-logo" v-lazy="ite.logo" />
              <img v-if="res.isbuy==false&&ite.number>=1" class="video-state" src="../../assets/icon_suo_yellow.png" alt="" />

              <p class="video-see" v-if="ite.hotLevel==1">必看</p>
            </div>
            <p class="spot-name hide" :class="(ite.number==switchScneNumber)?'curr':''">{{ite.spotname}}</p>
          </div>

        </div>
      </div>


      <!--新增附近推荐景区-->
      <div class="conference-list p024 half clearfix mt50" v-if="near!=null&&near.length>0">
        <div class="list-tit">附近推荐景区
          <router-link class="list-more" v-if="near.length>0" :to="{path:'/view-list',query:{siteid:siteid,sort:1,lat:res.bag.lat,lng:res.bag.lng,TimeStamp:TimeStamp,inputValue:'',appKey:appKeyA}}">查看更多</router-link>
        </div>
        <router-link class="conference-item-parent" :to="{path:'/view-detail',query: {shopid: item.id, TimeStamp: TimeStamp, appKey: appKeyA}}" v-for="(item,index) in near" v-if="index<4">
          <div class='conference-item border-box'>
            <div class="conference-item-img loadBg">
              <img class="img" v-lazy="item.logo" alt="">
            </div>
            <div class="conference-item-info clearfix">
              <div class="label-box">
                <div class="conference-item-title hide" style="max-width: 100%;">{{item.name}}</div>
              </div>
              <div class="right-info">
                <div class='conference-item-info-label'>
                  <img src="../../assets/station-icon-view.png" alt="">
                  <span class="icon-time">{{item.spots}}个讲解点</span>
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </div>


      <!--新增评论头部-->
      <div class="comments-list-top clearfix border-box" id="comments-list-top">
        <span class="fl">游客点评</span>
      <span @click="commentsShow" class="fr commentBtn">我要点评
        <img src="../../assets/icon-write.png" />
      </span>
      </div>

      <!--新增底部评论详情列表-->
      <div class="comments-list border-box account-list-sr">
        <div v-for="(item,index) in commentList" :key="index" class="comments-list-data box border-box">
          <p class="block head-img-box">
            <img class="img" v-lazy="item.rzimg?item.rzimg:item.headimg"/>
          </p>

          <div class="flex comments-list-info  border-box">
            <div class="comments-person-box box ">
              <div class="block comments-person">
                <p class="comments-person-name hide">{{item.name}}</p>
                <p class="star-level">
                  <template v-for="(star,index) in [2,4,6,8,10]">
                    <img v-if="item.score>=star" src="../../assets/icon_com.png"/>
                    <img v-else  src="../../assets/start_nor.png" />
                  </template>
                  <span class="icon-reward-small" v-if="item.isds&&res.noReward!=1">赏</span>
                </p>
              </div>
              <p @click="uploadZan(index)" class="praise">
                <span>{{item.totalZan}}</span>
                <img v-if="item.iszan==1" src="../../assets/zan_already.png" />
                <img v-else src="../../assets/zan_already_no.png" />
              </p>
            </div>

            <div class="comments-detail border-box">
              <p class="comments-detail-top">{{item.content}}</p>
            </div>

            <div v-if="item.allimg" class="comments-img box border-box">
              <img v-for="(ite,index) in item.allimg"  @click="seeImg(index,item.allimg)" v-lazy="ite" />
            </div>

            <div class="block comments-person-time">
              {{item.addtime}}
              <!--<span @click="replay" class="comments-person-hf fr" v-if="res.isguide && item.replys.length<1"><img src="../../assets/icon_play_btn11.png" />回复</span>-->
              <span v-if="item.state==2" class="shz-text fr none">审核中</span>
            </div>

            <div v-if="item.replys" class="comments-detail-replay border-box">
              <div v-for="(item,index) in item.replys" :key="index" class="comments-replay-text">
                <span>{{item.bagname}}</span> 回复
                <span>{{item.name}}</span> ：{{item.content}}
              </div>
            </div>
          </div>
        </div>
        <router-link :to="{path:'/comment',query: {id:this.$route.query.id,isbuy:res.isbuy,isguide:res.isguide, TimeStamp: TimeStamp, appKey: appKeyA}}">
          <div class="bottom-box border-box">
            <p class="select-more">查看共{{commentListLen}}条评论</p>
          </div>
        </router-link>

        <p class="load-tip" ref="loadtip" style="display: none;"></p>
      </div>
    </div>

    <!--大足石刻样式-->
    <div class="main-scroll-view main-scroll-view2" style="position: relative; width: 100%; height: auto;" v-if="newStyle">
      <img class="video_play_bg" src="../../assets/video-bg.jpg" alt="">

      <!--顶部视频信息-->
      <div class="list border-box list1">

        <div class="list-box box border-box">
          <div class="block list-img">
            <img class="img icon-tx" :src="bagInfo.guideheadimg2?bagInfo.guideheadimg2:bagInfo.guideheadimg" alt="" @click="goGuideInfo(id)">
          </div>

          <div class="block flex list-info">
            <!--语音名称-->
            <p class="list-group hide">
              <span class="fl hide" style="width: 100%;">{{bagInfo.name}}</span>
            </p>

            <p class="list-name hide">
              {{bagInfo.guidename2?bagInfo.guidename2:bagInfo.guidename}}
              <span v-if="bagInfo.guidetag">/{{bagInfo.guidetag?bagInfo.guidetag:''}}</span>
            </p>


            <!--新增星级评分-->
            <div class="star-box-new clearfix">
              <img :src="(bagInfo.hotlevel>=2)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
              <img :src="(bagInfo.hotlevel>=4)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
              <img :src="(bagInfo.hotlevel>=6)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
              <img :src="(bagInfo.hotlevel>=8)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
              <img :src="(bagInfo.hotlevel>=10)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
              <span>{{bagInfo.hotlevel}}分</span>
            </div>
          </div>
        </div>

        <div v-if="bagInfo.guideinfo && bagInfo.guideinfo.length>0" class="list-box-info" :class="guideInfoState==0 && bagInfo.guideinfo && bagInfo.guideinfo.length>60?'hide2':''" @click="guideInfoStateFun">{{bagInfo.guideinfo}}</div>


        <div class="list-video-con border-box">
          <!--<div class="list-video-name hide">{{bagInfo.name}}</div>-->
          <div class="list-time-num clearfix">
            <p class="fl" v-if="bagInfo.listen>=0">
              <img src="../../assets/adot-5.png" />
              {{bagInfo.listen|initNumber}}次播放
            </p>
            <p class="fl" v-if="(bagInfo.dsnum>=0&&bagInfo.buynum<=0&&res.noReward!=1)|| noBuys.indexOf(shopid)>-1">
              <img src="../../assets/adot-3.png" />
              {{bagInfo.dsnum|initNumber}}人打赏
            </p>
            <p class="fl" v-else-if="(bagInfo.buynum>0&&bagInfo.price>=0) && noBuys.indexOf(shopid)<=-1">
              <img src="../../assets/adot-3.png" />
              {{bagInfo.buynum|initNumber1}}人购买
            </p>

            <div class="list-share" @click="showPoster">
              <img src="../../assets/icon-share-btn.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <!-- 切换 -->
      <div class="tab-box box">
        <div class="flex" :class="tabState==1?'curr':''" @click="tabState=1">
          <div>
            <span class="txt">景点解说</span>
            <span class="line"></span>
          </div>
        </div>
        <div class="flex" :class="tabState==2?'curr':''" @click="tabState=2">
          <div>
            <span class="txt">评价打赏</span>
            <span class="line"></span>
          </div>
        </div>
        <div class="flex" :class="tabState==3?'curr':''" @click="tabState=3" v-if="near!=null&&near.length>0">
          <div>
            <span class="txt">附近推荐</span>
            <span class="line"></span>
          </div>
        </div>
      </div>

      <!-- 语音解说 -->
      <div class="voice-box" v-if="tabState==1">
        <div class="voice-list border-box clearfix" v-for="(item,index) in voicetmp" :key="index">
          <div class="list-title">
            <img src="../../assets/station-icon-adress1.png" alt="">
            {{optionInd[index]}}-{{item.pspotname}}
          </div>

          <div class="spot-station" v-for="(item1,index1) in item.list" :key="index1">
            <div class="spot-img" v-if="item1.splashimg">
              <img class="img" :src="item1.splashimg" alt="">
              <p class="mask"></p>
            </div>

            <div class="voice-item clearfix">
              <div class="item-top border-box" :class="(ite.number==switchScneNumber)?'curr':''" v-for="(ite,ind) in item1.list" :key="ind" :id="'video-list-spotid'+ite.spotid">
                <div class="item-info border-box" @click="openVR(ite.number)">
                  <span class="list-video-mask"></span>
                  <img class="icon_360" src="../../assets/icon_360.png" alt=""/>
                  <img class="img" v-lazy="ite.logo" alt="" />
                  <p class="video-label" v-if="res.isbuy==false&&ite.number==0">免费试看</p>
                  <p class="video-label" v-else-if="ite.hotLevel==1">必看</p>
                  <img class="video-state" src="../../assets/icon_35.png" alt="" v-if="res.isbuy==false&&ite.number>=1" />
                </div>
                <p class="item-name hide">{{optionInd[index]}}{{ite.number+1}}-{{ite.spotname}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 评价打赏 -->
      <div class="voice-pjds border-box" v-if="tabState==2">
        <div class="voice-ds clearfix" @click="rewardShowFun" v-if="res.noReward!=1">
          <div class="fl ds-img" v-if="res.dsimgs && res.dsimgs.length>0">
            <img v-lazy="item.rzimg?item.rzimg:item.img" alt="" v-for="(item,index) in res.dsimgs" v-if="index<6" />
          </div>
          <div class="fl ds-num" v-if="bagInfo.dsnum>0">已有{{bagInfo.dsnum}}人打赏</div>
          <div class="fl ds-num" v-else>暂无打赏</div>
          <div class="fr ds-btn">打赏</div>
        </div>
        <div class="voice-pj">
          <div class="voice-pj-top clearfix">
            <div class="fl">最新评价</div>
            <div class="star fl">
              <img src="../../assets/star_curr1.png" alt="">
              <img src="../../assets/star_curr1.png" alt="">
              <img src="../../assets/star_curr1.png" alt="">
              <img src="../../assets/star_curr1.png" alt="">
              <img src="../../assets/star_nor.png" alt="">
              9.8分
            </div>
            <div class="fr pj-btn" @click="commentsShow">
              我要点评<img src="../../assets/icon-write.png" alt="">
            </div>
          </div>
          <div class="">
            <div class="pj-item box" v-for="(item,index) in commentList">
              <img class="head-img"  v-lazy="item.rzimg?item.rzimg:item.headimg" alt="">
              <div class="flex pj-con">
                <div class="pj-t box">
                  <div class="l flex">
                    <div class="name hide">{{item.name}}</div>
                    <div class="star clearfix">
                      <template v-for="(star,index) in [2,4,6,8,10]">
                        <img v-if="item.score>=star" src="../../assets/star_curr1.png"/>
                        <img v-else  src="../../assets/star_nor.png" />
                      </template>
                      <div class="fl icon-reward-small" v-if="item.isds&&res.noReward!=1">赏</div>
                    </div>
                  </div>
                  <div class="r zan" @click="uploadZan(index)">
                    <span class="fl">{{item.totalZan}}</span>
                    <img v-if="item.iszan==1" src="../../assets/zan_already.png" />
                    <img v-else src="../../assets/zan_already_no2.png" />
                  </div>
                </div>
                <div class="pj-txt">{{item.content}}</div>
                <div class="pj-img box border-box" v-if="item.allimg" >
                  <img  v-for="(ite,index) in item.allimg"  @click="seeImg(index,item.allimg)" v-lazy="ite" alt="">
                </div>
                <div class="pj-time">{{item.addtime}}</div>
                <div v-if="item.replys" class="comments-detail-replay border-box">
                  <div v-for="(item,index) in item.replys" :key="index" class="comments-replay-text">
                    <span>{{item.bagname}}</span> 回复
                    <span>{{item.name}}</span> ：{{item.content}}
                  </div>
                </div>
              </div>
            </div>

            <router-link :to="{path:'/comment',query: {id:this.$route.query.id,isbuy:res.isbuy,isguide:res.isguide, TimeStamp: TimeStamp, appKey: appKeyA}}">
              <div class="more-pj">查看共{{commentListLen}}条评论</div>
            </router-link>
          </div>
        </div>
      </div>


      <!--新增附近推荐景区-->
      <div class="conference-list half clearfix" v-if="near!=null&&near.length>0&&tabState==3" style="padding: 0 .24rem .5rem;background-color: #fff;">
        <div class="clearfix">
          <router-link class="conference-item-parent" :to="{path:'/view-detail',query: {shopid: item.id, TimeStamp: TimeStamp, appKey: appKeyA}}" v-for="(item,index) in near">
            <div class='conference-item border-box'>
              <div class="conference-item-img loadBg">
                <img class="img" v-lazy="item.logo" alt="">
              </div>
              <div class="conference-item-info clearfix">
                <div class="label-box">
                  <div class="conference-item-title hide" style="max-width: 100%;">{{item.name}}</div>
                </div>
                <div class="right-info">
                  <div class='conference-item-info-label'>
                    <img src="../../assets/station-icon-view.png" alt="">
                    <span class="icon-time">{{item.spots}}个讲解点</span>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>

        <div class="load-tip2" style="margin-top: .3rem;">已经到底了</div>
      </div>

    </div>

    <!--底部购买按钮-->
    <div v-if="res.isbuy==false" :class="['bottom-btn-box', 'border-box', 'box', shopid=='1603'||shopid=='1810'?'yn':'']">
      <div @click="commentNumClick()" class="video-listen">
        <img class="icon_play_num" src="../../assets/icon_play_num3.png" />
        <span v-if="bagInfo.comments>0">{{bagInfo.comments}}</span>
      </div>
      <!--<button class="flex bottom-btn" style="background-color:#fff;color:#4d4d4d;" @click="showOTA()">激活码</button>-->
      <div class="flex bottom-btn__yn" @click="buyVideo()" v-if="shopid=='1603'||shopid=='1810'">
        <div class="lf">
          <div class="price">
            <span>￥</span>
            <b>{{bagInfo.price}}</b>
          </div>
          <div class="txt">
            包含所有展厅VR真人讲解<br/>一次购买，
            <template v-if="shopid==1603">
            有效期60天
          </template>
          <template v-if="shopid==1810">
            长期有效
          </template>
          </div>
        </div>
        <div class="rt">
          购买
        </div>
      </div>
      <button class="flex bottom-btn" @click="buyVideo()" v-else>{{bagInfo.price}}元购买收看</button>
    </div>

    <!--返回上一页按钮-->
    <div class="link-btn" @click="back" v-if="shopid!=714 && isback!=2 && !isWxMini">{{isback==1?'返回':'景区主页'}}</div>

    <!--点击屏幕加号按钮弹窗事件-->
    <p @click="videoPlay" class="btn-add none">{{memuText}}</p>
    <div class="alert-box alert-box-con" :class="{'none':menuCurr==0,'curr':menuCurr==1}">
      <p @click="videoPlay" class="mask"></p>
      <div class="btn-add-box" @click="videoPlay">
        <p @click.stop="commentsShow" class="animate animate1">评论</p>
        <p @click.stop="feedbackFun" class="animate animate2">反馈</p>
        <router-link class="animate animate3" to="/user">我的</router-link>
      </div>
    </div>


    <!--全景视频弹窗-->
    <div class="video-alert" :class="windowResize==1?'windowW':''" v-show="videoAlert==1">
      <p class="video-tip" @click="closeVR()">返回<img src="../../assets/h5_logo.png" alt=""></p>
      <p class="video-tip" @click="back1()" v-if="id==4213" style="top: 50px;font-size: 12px;letter-spacing: 0; padding-left: 12px; width: 81px;">历史原貌再现</p>

      <p class="video-vricon" @click="toVRVoice()" v-if="bagInfo.isburl==1 && res.isbuy && vrIconShow">
        <img src="../../assets/icon_close2.png" alt="" @click.stop="vrIconShow=false">
      </p>

      <div class="vr-point" :style="item.vrPointStyle" v-for="(item,index) in maolist" :key="index" v-if="item.isshow==1 && isBegin" @click="vrContShowFun(item)">
        <p class="vr-txt" :class="'colr'+item.color" v-if="item.title">{{item.title}}</p>
        <div class="vr-dot" :class="'colr'+item.color"></div>
      </div>
      <!--<img class="video-close" @click="closeVR()" src="../../assets/icon_close.png" alt="">-->
      <!--<div id="example"></div>-->
      <!--<div class="video-alert-mask" v-if="videoAlertMask==1">-->
        <!--<img src="../../assets/video-qj-icon.png" alt="">-->
        <!--<span class="video-alert-btn" @click="videoAlertMask=0">知道了</span>-->
      <!--</div>-->

      <div id="panoDesk"></div>
      <div class="toolTxt" v-if="bagList && bagList.length>0 && bagList[switchScneNumber] && bagList[switchScneNumber].txtarr && txtcurr">{{txtcurr}}</div>
      <div class="toolBar" id="toolBar">
        <div class="toolBox" ref="toolBox"  :style="'width: '+ toolBoxW +'px;'">
          <div class="toolBtn" :id="'toolBtn'+item.id" :class="switchScneNumber==item.number?'curr':''" v-for="(item,index) in bagList" :key="index" @click="switchScne(item.number)">
            <img  v-lazy="item.logo" alt="">
            <p class="video-see" v-if="item.hotLevel==1">必看</p>
            <div class="toolBtn-tit">
              <p class="p1 hide">{{item.spotname}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="alert-box alert-info" v-if="vrContShow" id="vrCont">
      <div class="mask" @click="vrContShow=0"></div>
      <div class="alert-con border-box">
        <img src="../../assets/vr-close.png" alt="" class="close" @click="vrContShow=0">
        <div class="tit tc border-box hide">{{vrContShow.title?vrContShow.title:bagList[switchScneNumber].spotname}}</div>
        <div class="info-scroll border-box">
          <div class="txt" v-html="vrContShow.cont" v-if="vrContShow.cont" ref="content" @click="imageEnlargement"></div>
          <div class="txt" v-html="bagList[switchScneNumber].sub" v-else></div>

          <img v-for="(ite,ind) in (bagList[switchScneNumber].allimg).split(',')"  @click="seeImg(ind,(bagList[switchScneNumber].allimg).split(','))" v-lazy="ite"  :key="ite" v-if="bagList[switchScneNumber].allimg && !vrContShow.cont"/>
        </div>
      </div>
    </div>


    <!--新版本打赏弹窗8-20-->
    <AlertReward :bagInfo="bagInfo" :res="res" :that="that" :dsImgs="res.dsimgs" :class="{'curr':rewardShow==1,'none':rewardShow!=1}" @child-Reward="closeReward"></AlertReward>

    <!--新版本评论弹窗8-21-->
    <AlertComment :bagInfo="bagInfo" :class="{'curr':commentShow==1,'none':commentShow!=1}"  @child-Comment="closeComment"></AlertComment>

    <!--试听结束弹窗新版-->
    <AlertListenEnd  :bag="bag" :couponid="couponid" :extral="extral" @close="closeEnd" v-if="Object.keys(bag).length>0"></AlertListenEnd>

    <!--意见反馈弹窗-->
    <AlertFeedback :class="{'none':feedbackShow==0,'curr':feedbackShow==1}" v-on:child-Feedback="closeFeedback"></AlertFeedback>

    <audio id="Audio" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>

    <!--海报弹窗-->
    <AlertPoster  :id="id" :type="'guide'" @close="closePoster" v-if="posterShow==1"></AlertPoster>

    <!--提醒用户购买弹窗弹窗-->
    <AlertPayTip @close="closePayTip" :comeForm="'2'" :price="bagInfo.price" :buybtn="buyVideo" v-if="buyTip==1"></AlertPayTip>

    <!--OTA-->
    <AlertOTA  :OTAcode="OTAcode" :bagInfo="bagInfo"  @close="closeOTA" v-if="OTAcodeShow==1"></AlertOTA>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>

    <!--<script type="text/javascript" src="./static/videoVR/build/three.js"></script>-->
    <!--<script type="text/javascript" src="./static/videoVR/js/renderers/CanvasRenderer.js"></script>-->
    <!--<script type="text/javascript" src="./static/videoVR/js/renderers/Projector.js"></script>-->
    <!--<script type="text/javascript" src="./static/videoVR/build/mxreality.js"></script>-->

  </div>

</template>

<script>
//  import PhotoSphereViewer from 'photo-sphere-viewer'
//  import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
  import { mapState, mapMutations } from 'vuex'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import AlertReward from '../../components/AlertReward'
  import AlertComment from '../../components/AlertComment'
  import AlertListenEnd from '../../components/AlertListenEnd'
  import AlertFeedback from '../../components/AlertFeedback'
  import AlertPoster from '../../components/AlertPoster'
  import AlertOTA from '../../components/AlertOTA'
  import AlertPayTip from '../../components/AlertPayTip'
  import P400 from '../../components/P400'
  import {getVideoPlay, getBagComment, getZan, uploadUserBrowse, getPopComment, getOTAcode, getvoicebagdetail,getVrmaoList,getVrmaoUpload} from "@/service/getData";
  import {wxImgPreview, wxShareme,listenEndOrder, creatOrder, pushOrder,playRecord, getWxMini, getSrtTxt } from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'

  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  var fromPath,fullPath;
  var MyPlayerObj = null,txtTimer = null;
  export default {
    data(){
      return{
        isback: this.$route.query.isback || '', //是否显示返回按钮
        sregion: '', //省站点id:430000
        siteid: '', //站点id
        id: '', //专辑id
        spotid: '', //景点id
        shopid: '', //景区id
        userInfo: {}, //用户信息
        currRewardShow: false,   //当前语音未弹出过打赏弹窗  true已弹出过打赏弹窗
        res:{
          isReward: false,  //未打赏过  true已打赏过
          noReward: 1 // 0自愿打赏 1关闭打赏 2强制打赏
        },//接口所有数据
        bagInfo:'',//专辑详情
        voice:[],//语音
        bagList:[],//语音列表
        commentList:[],//评论数据
        commentList1:[],//弹幕评论数据
        commentListLen:0,//评论条数
        commentShow:0,//评论弹窗
        rewardShow:0,//打赏弹窗
        bodyHide:0,//页面是否滚动
        memuText:'菜单',//菜单按钮文字
        menuCurr:0,//菜单按钮动画
        feedbackShow:0,//意见反馈弹窗
        isDs: false, //是否打赏过
        guideInfoState:0,//导游简介状态 0：两行隐藏 1：全部显示

        Audio: '', //音频dom
        videoTimer: null, //语音播放计时器
        isplay: 0, //当前语音是否播放
        currSlider: 0, //当前进度条
        currIndex: -1, //当前播放音频数组下标
        index1: 0, //当前播放音频数组下标(用来记录currIndex，传值给下订单方法)
        bag:{}, //当前试听的专辑
        extral:{}, //存放下单需要的值
        couponid: '', //优惠券id

        action: '', //订单推送消息

        currVRindex: -1,//当前播放的VR视频下标
        TimeStamp: new Date().getTime(),  //获取当前时间
        hasVideo:0,//导游是否有视频
        video:'',//导游视频
        videoimg:'',//导游视频封面
        isVideoPlay: false,  //视频没有在播放
        appKey:'',
        appKeyA: '',
        form: '', //来自哪个页面
        posterShow: 0, //分享海报弹窗
        OTAcode: '', //OTA激活码
        OTAcodeShow: 0, //OTA激活码弹窗
        videoAlert:0,//全景视频弹窗
        videoAlertMask:1,//全景视频弹窗蒙层
        near:[],
        vr: null,
        scene: null,
        renderer: null,
        container: null,
        firstTime: true,
        currTime: -1,
        canbtn: false,
        scenesArr: [], //全景视频重组


        P400: 0, //系统维护中
        PSV: null, //全景图片
        windowResize:'',//手机横竖屏设置 0:竖屏 1：横屏

        toolBoxW: 0, //底部预览图部分的宽度
        switchScneNumber: 0, //当前播放的
        preNumber: '', //上一个播放的

        buyTip: 0, //购买提醒弹窗
        label: this.$route.query.label || '', //turn: 默认弹出视频播放弹窗

        isWxMini: false, //返回是否是小程序环境
        noBuys: '907,1334,1828,264', //不显示购买量的景区shopid

        txtcurr: '', //当前显示的字体
        cutTime: -1, //卡顿时的时间
        vrIconShow: true, //是否显示去听语音的图标
        vrPointStyle: {left: '-200px', top: '-200px'},
        vrContShow: 0,//热点详情弹窗
        maolist: [], //某个视频对应的热点
        isBegin: false, //是否开始播放
        isOpenVr: false,

        newStyle: 0, //新版大足石刻样式
        tabState:1,//1：语音解说 2：评价打赏 3：附近推荐
        optionInd: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
        voicetmp: [], //复制并重构voice数据
      }
    },
    computed: {

    },
    created() {
      this.that = this;
      this.global.set_glabalClear();
      this.siteid = getStore("siteid") || "";
      this.sregion = getStore("sregion") || "";
      this.id = this.$route.query.id;
      this.spotid = this.$route.query.spotid;
      this.shopid = this.$route.query.shopid;
      this.form = this.$route.query.form;
      if (this.$route.query.video == 1) {
        this.isOpenVr = true;
      }
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
        this.sendUserBrowse();
      }else{
        setStore("appKey", {"appKey":""});
      }

      this.action = this.$route.query.action;
      let self = this;
      if(this.action == "cancel"){
        this.$confirm({
          title: '提示',
          content: '取消推送授权，退出后将找不到页面入口，需要重新授权吗？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            pushOrder('dist/index.html#/video-vr?id='+self.id+'&spotid='+self.spotid+'&shopid='+ self.shopid + '&TimeStamp='+ self.TimeStamp+'&bagtype=2' + '&appKey='+ (self.appKey));
          }

        }).catch(function(res){
          if(res == 'success') {
            pushOrder('dist/index.html#/video-vr?id='+self.id+'&spotid='+self.spotid+'&shopid='+ self.shopid + '&TimeStamp='+ self.TimeStamp+'&bagtype=2' + '&appKey='+ (self.appKey));
          }
        })
      }

      this.$loading.show('数据加载中');
      this.initData();
      this.initComment();
      this.renderResize();

      getWxMini(function(res){
        self.isWxMini =  res;
      });

      window.addEventListener("scroll",function(){});

      this.$nextTick(() => {
        window.addEventListener("resize", this.renderResize, false)
      });

    },
    beforeDestroy(){
      window.removeEventListener("scroll",function(){});
      window.removeEventListener("resize", this.renderResize, false)
      if (this.PSV) {
        this.PSV.destroy()
      }
      if(MyPlayerObj){
        this.closeVR();
      }
      this.clearTxt();
    },
    beforeRouteEnter (to, from, next) {
      if(from.path.indexOf('video-vr') > -1){
        fromPath = 'video-vr';
        fullPath = to.fullPath;
      }
      next();
    },
    mounted(){

      if(fromPath == 'video-vr'){
        this.$router.replace({
          path: fullPath
        });
      }
      if(this.form == 'pay'){
        window.addEventListener("popstate", function(e) {
          window.history.go(-6);
        }, false);
        pushHistory();
        function pushHistory() {
          var state = {
            title: "title",
            url: ""
          };
          window.history.pushState(state, "title", "");
        }
      }

      this.$nextTick(function () {
        window.addEventListener("resize", this.renderResize, false)
      });

    },
    methods: {

      async initData(){
        var self = this;
        this.userInfo = getStore("userInfo");

        let res = await getVideoPlay({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          bagid: this.id,
          siteid: this.siteid,
          sregion: this.sregion,
          page:1,
          rows: 12
        });

        if (res.errcode === "00000"){
          this.$loading.hide();
          this.res = res.data;
          this.bagInfo = res.data.bag;
          this.shopid = this.bagInfo.shopid;
          setStore("bagInfo",this.bagInfo);
          this.voice = res.data.voice;
          this.bagList = res.data.voiceList;
          this.near = res.data.nearshop;

          var newStyleState =  1;
          var voicetmp = [];
          for(var i=0;i<res.data.voice.length;i++){
            var voice_1 = {};
            voice_1.pspotname=res.data.voice[i].pspotname;
            voice_1.list = [];
            var voice_1_1 = {};
            voice_1_1.splashimg = res.data.voice[i].splashimg;
            voice_1_1.list = [];
            if(newStyleState==1 && res.data.voice[i].splashimg){
              this.newStyle = 1;
              newStyleState = 0;
            }
            for(var j = 0 ; j < res.data.voice[i].list.length; j++){
              if (j==res.data.voice[i].list.length-1){
                voice_1_1.list.push(res.data.voice[i].list[j]);
                var tm = voice_1_1;
                voice_1.list.push(tm);
                break;
              }
              if (res.data.voice[i].list[j].splashimg == null || res.data.voice[i].list[j].splashimg == ''){
                voice_1_1.list.push(res.data.voice[i].list[j]);
              }else{
                voice_1_1.list.push(res.data.voice[i].list[j]);
                var tm = voice_1_1;
                voice_1.list.push(tm);
                voice_1_1 = {};
                voice_1_1.splashimg = res.data.voice[i].list[j].splashimg;
                voice_1_1.list = [];

                if(newStyleState==1 && res.data.voice[i].list[j].splashimg){
                  this.newStyle = 1;
                  newStyleState = 0;
                }
              }
            }
            voicetmp.push(voice_1);
          }

          console.log(this.newStyle);
          this.voicetmp = voicetmp;


//          this.bagList[1].url={"720":"http://jpjstest.geeker.com.cn/dist/static/test.mp4","1080":"https://vr-1252493175.cos.ap-chengdu.myqcloud.com/jpjs/upload/file/20230525/1684982721859compress1080.mp4"}


          this.getSrtTxtFun();

          //新增start
          if(res.data.bag.video!='null'&&res.data.bag.video!=''){
            this.video = res.data.bag.video;
            this.videoimg = res.data.bag.videoimg;
          }

          if(this.$route.query.rewardShow == 1){
            this.rewardShow = 1
          }

          if(this.form == "spot"){
            this.index1 = this.getIndex(this.bagList,this.spotid);
          }

          if(res.data.isPosition == 1){
            this.index1 = this.getIndex(this.bagList,this.spotid);
            this.switchScneNumber = this.index1;
            setTimeout(function(){
              self.scollToComment('video-list-spotid'+self.spotid,-50);
            },1000);
          }else {
            document.documentElement.scrollTop = document.body.scrollTop = 0;
          }
          var share = res.data.share;
          let link = '/video-vr?id='+ this.id +'&spotid='+ this.spotid +'&shopid='+ this.shopid +'&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          if(share == null){
            let title = '金牌解说 | ' + this.bagInfo.name;
            let desc = '我是'+ this.bagInfo.guidename2 +'，我在“金牌解说”为您讲解'+ this.bagInfo.shopname +'的历史故事';
//            let img = this.bagInfo.tvideourl || this.bagInfo.vrimg || '';
            let img = this.bagInfo.guideheadimg2 || this.bagInfo.guideheadimg || '';
            wxShareme(title,desc,img,link);
          }else {
            wxShareme(share.title,share.desc,share.logo,link);
          }

          this.$route.meta.title = this.bagInfo.shopname;

          if(this.label=='turn' && this.bagList.length>0){
            this.openVR(0);
          }
          // video === 1 时打开vr播放
          if (this.isOpenVr) {
            this.openVR(this.switchScneNumber);
          }
        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }

        let res1 = await getPopComment({
          TimeStamp: this.TimeStamp,
          page: 1,
          roes: 10,
          bagid: this.id
        });
        if (res1.errcode === "00000"){
          if (res1.data.length > 0) {
            this.commentList1 = res1.data;
          }
        }
      },

      //上传浏览数据
      async sendUserBrowse(){
        this.userInfo = getStore("userInfo");
        let res = await uploadUserBrowse({
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      async initComment(){
        let res = await getBagComment({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          page: 1,
          rows: 5,
          bagid: this.id
        });

        if (res.errcode === "00000"){
          if (res.data.root.length > 0) {
            this.commentList = res.data.root;
            this.commentListLen = res.data.total;
          }
        }
      },

      //获取当前视频锚点列表
      async getVrmaoListFun(id){
        let res = await getVrmaoList({
          id: id
        });

        if (res.errcode === "00000"){
          this.maolist = res.data.list;
        }
        this.isBegin = false;
      },
      //锚点事件点击提交
      async getVrmaoUploadFun(id){
        let res = await getVrmaoUpload({
          id: id
        });
      },

      //页面滑动到指定标签id位置
      scollToComment(elmid,top){
        let self = this;
        self.$nextTick(function() {
          var dom = document.getElementById(elmid);
          if(dom && dom != null){
            if(top){
              window.scrollTo(0,Number(self.offSet(dom)+top));
            }else {
              window.scrollTo(0,self.offSet(dom));
            }
          }
        });
      },

      offSet(curEle){
        var totalTop = null;
        var par = curEle.offsetParent;
        //首先把自己本身的相加
        totalTop += curEle.offsetTop;
        //现在开始一级一级往上查找，只要没有遇到body，我们就把父级参照物的边框和偏移相加
        while (par){
          //把父级参照物的偏移相加
          totalTop += par.offsetTop;
          par = par.offsetParent;
        }
        return totalTop;
      },

      //打赏弹窗显示隐藏
      rewardShowFun(){
        this.rewardShow = 1;
      },
      //评论弹窗隐藏
      closeComment :function(msg){
        this.commentShow = msg.commentShow;
        if(msg.success){
          this.initComment();
        }
      },
      //打赏弹窗隐藏
      closeReward :function(msg){
        this.rewardShow = msg.rewardShow;
        if(msg.success){
//          this.initData();
          this.bagInfo.dsnum++;
        }
      },
      //意见反馈弹窗隐藏
      closeFeedback :function(feedbackClose){
        this.feedbackShow = feedbackClose
      },
      //菜单按钮动画
      videoPlay(){
        if(this.menuCurr==1){
          this.menuCurr=0
          this.memuText='菜单'
        }else{
          this.menuCurr=1
          this.memuText='关闭'
        }
      },

      //关闭购买提醒弹窗
      closePayTip(msg){
        this.buyTip = msg;
      },

      //显示与隐藏意见反馈
      feedbackFun(){
        if(this.feedbackShow==0){
          this.feedbackShow=1
          this.menuCurr = 0
          this.memuText = '菜单'
        }else{
          this.feedbackShow=0
          this.menuCurr = 1
          this.memuText = '关闭'
        }
      },

      //评论弹窗显示隐藏
      commentsShow(){
        if(!this.res.isbuy){
          this.menuCurr = 0
          this.memuText = '菜单'
          this.$toast('请先购买')
        }else{
          //this.bodyHide = 1
          this.menuCurr = 0
          this.memuText = '菜单'
          this.commentShow = 1
        }
      },

      //用户评论点赞
      async uploadZan(index){
        let res = await getZan({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          commentid: this.commentList[index].id
        });
        if(res.errcode == "00000"){
          this.commentList[index].totalZan++;
          this.commentList[index].iszan = 1;
          this.$toast("点赞成功",{ location: ''})
        }else{
          this.$toast(res.errmsg,{ location: ''})
        }
      },



      //点击购买，调用下订单公用方法
      buyVideo(){
        let self = this;

        setStore("source", {"source": "video"});
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+self.bagInfo.id+'&cid='+self.couponid+'&shopid='+self.bagInfo.shopid+'&bagtype=2'+'&appKey='+(self.appKey)}`
        });
      },

      //关闭试听弹窗，购买成功修改音频状态
      closeEnd(msg){
        this.bag = msg.bag;
        if(msg.isbuy){
          this.res.isbuy = true;
        }
      },

      //拿到数组中指定spotid的下标
      getIndex(arr,spotid){
        let result;
        if(arr.find(function(x) {return x.spotid == spotid;}) != undefined) {
          arr.find(function(x,i) {
            if(x.spotid == spotid){
              result =  i;
            }
          });
          return result;
        }else {
          return 0;
        }
      },

      //跳转到导游详情页
      goGuideInfo(id){
          if(this.res.guide2info==1){
              MtaH5.clickStat("video_play_person");
              this.$router.push({
                  path: `/guide-info?${'id='+ id + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
              });
          }
      },

      //图片预览
      seeImg(ind,imgs){
        wxImgPreview(imgs[ind],imgs);
      },


      //显示分享海报弹窗
      showPoster(){
        this.posterShow = 1;
      },

      //关闭分享海报弹窗
      closePoster(msg){
        this.posterShow = msg;
      },

      //关闭OTA弹窗
      closeOTA(msg){
        this.OTAcodeShow = 0;
        if(msg.isbuy){
          this.res.isbuy = true;
        }
      },

      //显示OTA弹窗
      async showOTA(){
        let res = await getOTAcode();
        if (res.errcode === "00000"){
          this.OTAcode = res.data
        }
        this.OTAcodeShow = 1
      },

      //点击上一曲
      prevPlay(){
        var playIndex = parseInt(this.currVRindex) == 0 ? (this.bagList.length -1) : (parseInt(this.currVRindex) - 1);
        this.openVR(playIndex);
      },
      //点击下一曲
      nextPlay(){
        var playIndex = (parseInt(this.currVRindex) == this.bagList.length -1) ? 0 : (parseInt(this.currVRindex) + 1);
        this.openVR(playIndex);
      },

      //打开全景视频
      openVR(index){
        var self = this;
        if(index==-1){
          this.initVR(this.currVRindex);
//          document.body.style='height:100%;overflow:hidden;';
        }else {
          if(this.res.isbuy == true || index < 1){
            this.videoAlert=1;
            if(this.currVRindex<0){
              this.videoAlertMask=1;
            }
            this.initVR(index);
//            document.body.style='height:100%;overflow:hidden;';
          }else {
            this.buyTip = 1;
//            this.$toast('请先购买该张VR专辑')
          }
        }

      },
      //关闭字幕计数器
      clearTxt: function (){
        if(txtTimer){
          window.clearTimeout(txtTimer);
          txtTimer = null
        }
      },
      //关闭全景
      closeVR(){
        var self = this;
        self.videoAlert=0;
        self.exitScne();
        self.clearTxt();
      },

      initVR(index) {
        var self = this;
        self.vrIconShow = true;
        self.switchScneNumber = index;
        var panoDesk = document.getElementById("panoDesk");
        if(panoDesk.innerHTML == ""){
          self.getVrmaoListFun(self.bagList[index].id);

          var scenesArr = self.getScenesArr();
          this.scenesArr = scenesArr;
          var params = {
            /*播放器参数配置*/
            container: document.getElementById("panoDesk"),
            name: "SceneViewer",
            loadingImg: '<img  src="'+require('../../assets/load.gif')+'" style="display:block;width:auto;height:12px" />',
            isDBClick: true,
            isGyro: false,
            scenesArr: scenesArr,
            initSceneId: index,
            initOverCallBack: function () { //SDK初始完成回调
              console.log("SDK初始完成回调");
              self.cutTime=-1;
              MyPlayerObj = this;
            },
            loadedStartCallBack: function(){ //播放器开始实例化
              console.log("播放器开始实例化");
              self.addMenuClick();
              self.changeVideoQuality();
            },
            loadedCallBack: function() { //场景加载完成回调
              console.log("视频场景加载完成回调");
              if(self.bagInfo.isLittlePlanetEffect){
                MyPlayerObj.api_normalView(2);
              }

              playRecord(self.bagList[self.switchScneNumber].id);
              if(self.preNumber!=self.switchScneNumber || self.bagList.length==1){
//                MyPlayerObj.api_setVideoCurTime(0);
              }

            },
            errorCallBack: function (e) { //播放器异常回调
              console.log("错误状态：" + e);

              if(self.res.isbuy && self.bagInfo.isburl==1){
                self.$confirm({
                  title: 'VR视频播放失败',
                  content: '视频加载失败，先去听语音解说吧',
                  yesText: '去听语音',  // 左边按钮文本,
                  noText: '重新加载',   // 设置右边按钮文本
                  component: wxConfirm
                }).then(function(res){
                  console.log(res)
                  if(res == 'success') {
                    self.toVRVoice();
                  }
                }).catch(function (res) {
                  console.log(res)
                  if (res == 'fail') {
                    location.reload();
                  }
                })
              }else {
                self.$alert({
                  title: 'VR视频播放失败',
                  content: '视频加载失败，刷新页面重新观看',
                  btnText: '刷新页面'
                }).then(function(res){
                  if(res == 'ok') {
                    location.reload();
                  }
                });
              }

            },
            videoPlayEndCallBack: function(e){ //视频播放结束回调（isVideoLoop为false 启用）
              console.log("视频播放结束回调");
              self.vrContShow=0;
              self.clearTxt();
              MyPlayerObj.api_setVideoCurTime(0);
              self.nextScne();
            },
            videoPlayerCallBack: function(){
              self.clearTxt();
              var txtarr = self.bagList[self.switchScneNumber].txtarr;
              if(txtarr && txtarr.length>0){
                self.showSrtTxt(txtarr);
              }
              self.isBegin = true;
            },
            videoTogglePlayCallBack: function(){
              if (!MyPlayerObj.api_getVideoPlayStatus()) {
                self.clearTxt();
              }
            },
            videoCanPlayerCallBack: function(){
              console.log('videoCanPlayerCallBack')

              // 获取当前播放时间
              let curr = MyPlayerObj.api_getVideoCurTime();
              // 缓存的最新帧
              var videoDom = MyPlayerObj.api_getVideoDom();
              if (!videoDom) return;
              var buf = videoDom.buffered;
              var leg = buf.length - 1;
              if (leg < 0) return;
              var buffer = buf.end(leg).toFixed(1);
              // 计算延迟 如果延迟大于5s（自己定义）认为卡顿
              if(buffer - curr >= 6 && self.cutTime==-1){
                console.log('卡顿了1')
                self.bufferCut();
              }
            },
            scenePanTiltFovChangerCallBack: function(){
              if(MyPlayerObj){
//                console.log(MyPlayerObj.api_getCurScenePTF())

                var maolist = self.maolist;
                for(var i=0; i<maolist.length; i++){
                  var xy = MyPlayerObj.api_sphereToScreen(maolist[i].pan,maolist[i].tilt);
                  maolist[i]['vrPointStyle'] = {left: xy.x+'px', top: xy.y+'px'}
                  self.$set(self.maolist, i, maolist[i]);
                }
                self.maolist = maolist;
//                console.log(maolist)
              }


            }
          };

          //todo：配置工具栏的多码率格式
          var TConfig = {
            videoQuality: 1,
            videoList: [
              {
                "Text": "4G流畅",
                "Quality": 1,
                "MP4": "http://cache.utovr.com/5b8d3395d6024c7e99c107627ae9c93c/L1_zgucy3i1hcllftu5.mp4",
                "RTMP": null
              },
              {
                "Text": "5G高清",
                "Quality": 2,
                "MP4": "http://cache.utovr.com/5b8d3395d6024c7e99c107627ae9c93c/L3_ngeaxawx1c88u8de.mp4",
                "RTMP": null
              }]
          };
          initLoad(params, function (playMode) {
            self.setToolBoxW(index);
          }, TConfig)
        }else {
          this.switchScne(index);
          (document.getElementById("toolBar")).scrollTo(document.getElementById("toolBtn"+this.bagList[index].id).offsetLeft,0)
        }
      },
      //播放卡顿处理
      bufferCut: function (time){
        var self = this;
//        setTimeout(function(){
//          if(time == MyPlayerObj.api_getVideoCurTime()){
            if(self.res.isbuy && self.bagInfo.isburl==1){
              self.$confirm({
                title: 'VR视频播放卡顿',
                content: '因网速原因，视频播放缓慢，先去听语音解说吧',
                yesText: '去听语音',  // 左边按钮文本,
                noText: '继续等待',   // 设置右边按钮文本
                component: wxConfirm
              }).then(function(res){
                console.log(res)
                if(res == 'success') {
                  self.toVRVoice();
                }
              })
            }else {
              self.$alert({
                title: 'VR视频播放卡顿',
                content: '因网速原因，视频播放缓慢，先去听语音解说吧',
                btnText: '继续等待'
              });
            }
            self.cutTime = 1;
//          }
//        },10000)

      },
      toVRVoice: function (){
        var self = this;
        self.$router.push({
          path: `/video-play-vr?${'id='+self.id+'&shopid='+self.shopid+'&spotid='+self.spotid+'&appKey='+self.appKey}`
        });
      },

      showSrtTxt:function(txtarr){
        var self = this;
        txtTimer = window.setTimeout(function(){
          var time = MyPlayerObj.api_getVideoCurTime();
          if(Math.round(time)>=self.bagList[self.switchScneNumber].totaltime){
            self.clearTxt();
            return
          }else {
            for(var i=0; i<txtarr.length; i++){
              if(time>txtarr[i].startTime && time<txtarr[i].endTime){
                self.txtcurr = txtarr[i].content;
              }
            }
            self.showSrtTxt(txtarr);
          }
        },400);
      },

      //重新计算底部预览图部分的长度
      setToolBoxW(index){
        let self = this;
        self.$nextTick(function () {
          self.toolBoxW = 130 * self.bagList.length;
            setTimeout(function(){
              (document.getElementById("toolBar")).scrollTo(document.getElementById("toolBtn"+self.bagList[index].id).offsetLeft,0)
            },800);

        })
      },
      //追加菜单元素点击事件
      addMenuClick(){
        console.log("追加菜单元素点击事件");
        setTimeout(function(){
          var dom = document.getElementById("videoMenu");
          if(dom && dom != null){
            dom.parentNode.removeChild(dom);
          }
          var parent = document.getElementById("videoBG");
          var child = document.getElementById("videoFullScreen");
          var menu = document.createElement("div");
          menu.setAttribute('id', 'videoMenu');
          menu.setAttribute('class', 'floatR floatW videoMenu2');
          parent.insertBefore(menu,child.nextSibling);

          var videoToolbar = document.getElementById("videoToolbar");
          var toolBar = document.getElementById("toolBar");
          toolBar.setAttribute('class', 'toolBar');
          menu.addEventListener("touchstart", function(e){
            e.stopPropagation();
            var menuClass = menu.getAttribute("class");
            if(menuClass == "floatR floatW videoMenu2"){ //隐藏底部菜单
              menu.setAttribute('class', 'floatR floatW videoMenu1');
              toolBar.setAttribute('class', 'toolBar toolBar1');
              videoToolbar.setAttribute('class', 'videoToolbar');
            }else {
              menu.setAttribute('class', 'floatR floatW videoMenu2');
              toolBar.setAttribute('class', 'toolBar');
              videoToolbar.setAttribute('class', '');
            }
          }, false);
        },800);

      },
      //切换视频清晰度
      changeVideoQuality(){
        var self = this;
        setTimeout(function(){
          var quality1 = document.getElementById("1");
          var quality2 = document.getElementById("2");
          var curVideoText = document.getElementsByClassName("curVideoText")[0];
          if(curVideoText) curVideoText.innerHTML = '4G流畅';
          quality1 && quality1.setAttribute('class', 'videoListDom videoListDomCheck');
          quality2 && quality2.setAttribute('class', 'videoListDom');
          quality1 && quality1.removeEventListener("touchstart", function(){}, false);
          quality1.addEventListener("touchstart", function(e){
            e.stopPropagation();
            console.log('quality1')
            curVideoText.innerHTML = '4G流畅';
            quality1.setAttribute('class', 'videoListDom videoListDomCheck');
            quality2.setAttribute('class', 'videoListDom');
            MyPlayerObj.api_changeVideoPath(self.bagList[self.switchScneNumber].url['720'])
          }, false);
          quality2 && quality2.removeEventListener("touchstart", function(){}, false);
          quality2.addEventListener("touchstart", function(e){
            e.stopPropagation();
            console.log('quality2')
            curVideoText.innerHTML = '5G高清';
            quality1.setAttribute('class', 'videoListDom');
            quality2.setAttribute('class', 'videoListDom videoListDomCheck');
            MyPlayerObj.api_changeVideoPath(self.bagList[self.switchScneNumber].url['1080'])
          }, false)
        },800)
      },

      //重组视频数据赋值给VR播放器
      getScenesArr() {
        var scenesArr = [];
        var voiceList = this.bagList;
        var self = this;
        voiceList.map(function(item, index){
          scenesArr.push(Object.assign({},{
            sceneId: item.number,
            sceneName: item.spotname,
            sceneFilePath: item.url['720'],
            sceneType: "Video",
            isVideoLoop: false,
            isVideoAutoPlay: true,
            initFov: item.initFov || 100, //默认值：90，当前场景的初始fov值 范围（10~150）
            initPan: item.rotate || 0,  //默认180，当前场景的初始pan值 范围（0 ~ 360）
            isLittlePlanetEffect: (self.bagInfo.isLittlePlanetEffect==1?true:false), //默认不加载小行星效果状态
          }))
        });
        return scenesArr;
      },

      preScne(){
        var index = parseInt(this.switchScneNumber) == 0 ? (this.bagList.length -1) : (parseInt(this.switchScneNumber) - 1);
        this.switchScne(index)
      },
      nextScne(){
        var index = (parseInt(this.switchScneNumber) == this.bagList.length -1) ? 0 : (parseInt(this.switchScneNumber) + 1);
        if(this.res.isbuy == true || index < 1){
          this.switchScne(index)
        }else {
          this.buyTip = 1;
        }
      },
      switchScne(index){
        if(this.res.isbuy == true || index < 1){
          if(index != this.switchScneNumber){
            this.preNumber = this.switchScneNumber;
            this.switchScneNumber = index;
            MyPlayerObj.api_setVideoCurTime(0);
          }

          this.getVrmaoListFun(this.bagList[index].id);

          console.log( document.getElementsByClassName("curVideoText")[0].innerHTML);
          var curVideoText = document.getElementsByClassName("curVideoText")[0];

          var scenesArr = this.scenesArr;
//          MyPlayerObj.api_changerSceneById(scenesArr[index].sceneId)
          if(curVideoText.innerHTML == '4G流畅'){
            MyPlayerObj.api_changeVideoPath(this.bagList[index].url['720'])
          }else {
            MyPlayerObj.api_changeVideoPath(this.bagList[index].url['1080'])
          }
          MyPlayerObj.api_setPanTiltFov(this.bagList[index].rotate || 0, 0, this.bagList[index].initFov|| 100); //设置当前视口的Pan，tilt，fov值



          var videoMenu = document.getElementById("videoMenu");
          var toolBar = document.getElementById("toolBar");
          var videoToolbar = document.getElementById("videoToolbar");
          var menuClass = videoMenu.getAttribute("class");
          if(menuClass == "floatR floatW videoMenu2"){ //隐藏底部菜单
            videoMenu.setAttribute('class', 'floatR floatW videoMenu1');
            toolBar.setAttribute('class', 'toolBar toolBar1');
            videoToolbar.setAttribute('class', 'videoToolbar');
          }

        }else {
          this.buyTip = 1;
        }
      },
      enterScne(){
        MyPlayerObj && MyPlayerObj.api_enterVRModel();
      },
      exitScne(){
        MyPlayerObj && MyPlayerObj.api_setVideoPause();
//        document.getElementById("panoDesk").innerHTML = "";
      },

      //返回上一页/返回景区首页
      back(){
        if(this.isback==1){
          MtaH5.clickStat("video_back");//专辑详情页面点击返回上一页
          this.$router.go(-1);//返回上一层
        }else {
          this.$router.push({
            path: `/view-detail?${'shopid='+ this.shopid +'&siteid='+ this.siteid + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }
      },
      back1(){
        window.location = 'https://site023217.c.daqctc.com/#/news-list/3Dfysp'
      },

      showPhotoVR(imgurl,obj){
       // var imgurl = require('../../assets/qj.jpg');
        this.PSV = PhotoSphereViewer({
          container: obj,
          panorama: imgurl,
          autoload: true, //自动播放
          time_anim: 2000, //默认2000
          anim_speed: '2rpm', //默认2rpm
          navbar: false  //不显示下面的导航栏
        });
      },

      //导游详情显示隐藏切换
      guideInfoStateFun(){
        if(this.guideInfoState == 0){
          this.guideInfoState = 1;
        }else{
          this.guideInfoState = 0;
        }
      },

      //判断横竖屏
      renderResize() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;
        var gyro = document.getElementById("videoGyro");
        var menu = document.getElementById("videoMenu");
        var videoToolbar = document.getElementById("videoToolbar");
        var toolBar = document.getElementById("toolBar");
        if(width > height) {
          this.windowResize = 1;
//          MyPlayerObj && MyPlayerObj.api_OpenGyro();
//          gyro && gyro.setAttribute('class', 'floatR floatW videoGyro2');
          menu && menu.setAttribute('class', 'floatR floatW videoMenu1');
          toolBar && toolBar.setAttribute('class', 'toolBar toolBar1');
          videoToolbar && videoToolbar.setAttribute('class', 'videoToolbar');
        }else{
          this.windowResize = 0;
          menu && menu.setAttribute('class', 'floatR floatW videoMenu2');
          toolBar && toolBar.setAttribute('class', 'toolBar');
          videoToolbar && videoToolbar.setAttribute('class', '');
        }
      },

      /**
       * 把 SRT 格式的字幕文件解析为字幕的对象数组，格式为:
       * [
       *      {sn: "0", startTime: 0.89, endTime: 7.89, content: "这里是一系列与Hadoop↵有关的其他开源项目："},
       *      {sn: "1", startTime: 8.38, endTime: 14.85, content: "Eclipse是一个IBM贡献到开源社区里的集成开发环境（IDE）。"}
       * ]
       *
       * @param  string srt 字幕文件的内容
       * @return 字幕的对象数组
       */
       parseSrtSubtitles:function(srt) {
         var subtitles = [];
         var textSubtitles = srt.split('\r\n\r\n'); // 每条字幕的信息，包含了序号，时间，字幕内容
         function getSeconds(val){
           let arr = val.split(/\,|\./)
           let sec = 0
           let a = arr[0].split(':')
           sec = Number(a[0])*60*60+Number(a[1])*60+Number(a[2])+arr[1]/1000
           return sec
         }
         for (var i = 0; i < textSubtitles.length; ++i) {
           var textSubtitle = textSubtitles[i].split('\r\n');

           if (textSubtitle.length >= 2) {
             var sn = textSubtitle[0]; // 字幕的序号

             var reg = /^(\d{2}):(\d{2}):(\d{2})[\.,](\d{1,3}) --\> (\d{2}):(\d{2}):(\d{2})[\.,](\d{1,3})/g;
             var regResult = reg.exec(textSubtitle[1]);
             var timeSplit = regResult[0].split(' --> ');
             var startTime = getSeconds(timeSplit[0]);
             var endTime = getSeconds(timeSplit[1]);

             var content   = textSubtitle[2]; // 字幕的内容

             // 字幕可能有多行
             if (textSubtitle.length > 2) {
               for (var j = 3; j < textSubtitle.length; j++) {
                 content += '\n' + textSubtitle[j];
               }
             }

             // 字幕对象
             var subtitle = {
               sn: sn,
               startTime: startTime,
               endTime: endTime,
               content: content
             };
             subtitles.push(subtitle);
           }
         }
         return subtitles;
       },
       //解析字幕
       getSrtTxtFun: function (){
         var self = this;
         var bagList = self.bagList;
         for(var i=0; i<bagList.length; i++){
           var srturl = bagList[i].srturl;
           if(srturl){
             self.requestTxt(srturl,bagList,i)
           }
         }
       },
       requestTxt: function (srturl,bagList,i){
         var self = this;
         getSrtTxt(srturl,function(res){
           self.bagList[i]['txtarr'] = self.parseSrtSubtitles(res);
           self.$set(bagList, i, bagList[i]);
         })
       },

       //热点点击事件
        vrContShowFun: function (item){
          this.vrContShow=item;
          this.getVrmaoUploadFun(item.id);
          console.log(this.bagList[this.switchScneNumber].allimg && !this.vrContShow.cont)

          if(item.cont){
            var cont = item.cont;
            var imageArr = [];
            cont.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {  //match表示img元素，capture表示img地址
              imageArr.push(capture);
            });
            this.imageArr = imageArr;
            console.log(this.imageArr)
          }
        },

        //富文本中图片点击事件
        imageEnlargement(e){
          if (e.target.nodeName == 'IMG') {//判断点击富文本内容为img图片
            wxImgPreview(e.target.currentSrc,this.imageArr);
          } else {
            console.log("点击内容不为img")
          }
        },

        //底部评论数量按钮
        commentNumClick(){
          if(this.newStyle){
            this.tabState = 2;
          }else {
            this.scollToComment('comments-list-top');
          }
        },


    },
    watch:  {
      bag(newVal,oldVal){
        if(Object.keys(newVal).length){
          listenEndOrder(this,this.index1,this.bagInfo,true);
        }
      },
      bagInfo(){
        var self = this;
        this.$nextTick(function(){
          if(self.bagInfo.vrimg && self.bagInfo.vrimg != '' && self.bagInfo.vrimg != null){
//            self.showPhotoVR(self.bagInfo.vrimg,'list-img');
          }
        })
      }
    },
    components: {
      AlertReward,
      AlertComment,
      AlertListenEnd,
      AlertFeedback,
      AlertPoster,
      wxConfirm,
      AlertOTA,
      AlertPayTip,
      P400
    },
    //格式化数据
    filters: {
      //格式化数字
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      },
      //格式化时间
      initTime: function (time) {
        let minute = parseInt(time / 60);
        let second = parseInt(time % 60);
        minute = minute >= 10 ? minute : "0" + minute;
        second = second >= 10 ? second : "0" + second;
        return minute + ":" + second;
      },
      initNumber1: function (num) { //重置购买数据
        if(num>=1000){
          num = '1000+'
        }
        return num;
      }
    },
  }

</script>

<style scoped>
  @import '../../style/alert.css';


  .page{padding-bottom:1.14rem; background-color: #fff; min-height: 98vh; }
  .page.bf{ background-color: #fff;}
  .page-yn{padding-bottom: 1.4rem;}

  .video_play_bg{width: 100%;height: 2.64rem;object-fit: cover; }
  /*顶部视频信息*/
  .list-time-num {height:.42rem;line-height:.42rem; margin-top: .45rem; }
  .list-time-num>p{display: inline-block;line-height:.42rem;margin-right:.22rem;font-size: .24rem; color: #676767;}
  .list-time-num img{float:left;width:auto;height:.4rem;margin-right: .12rem;margin-top: .01rem}
  .list-time-num>p.fr{margin-right: 0;font-size: .2rem;color: #757575;}
  .list{ position: relative;background: #fff;margin: -1.3rem .27rem 0;border-radius: .1rem;padding: .44rem .28rem .2rem;box-shadow: 0 0 0.25rem #f1f1f1;}
  .list1{box-shadow: 0 0 0.25rem #dfdfdf;}
  .list1 .list-group{color:#222;}
  .list1 .list-name,.list1 .star-box-new span{color: #666;}
  .list-box{width:100%;font-weight:bold;}
  .list-img{ float: left;position: relative;width: 2.14rem;height: 2.6rem;margin-top: -.92rem;}
  .list-img img.icon-tx{display:block;width:100%;height:100%;border-radius: .13rem;background-color: #fff;}
  .list-img img.video{position:absolute;bottom:0;right:0;width:.81rem;height:.46rem;border-radius:0 0 .13rem 0; }
  .list-info{position:relative;padding-left: .28rem;padding-right: 0; }
  .list-group{font-size:.32rem;color:#555;}
  .list-name{margin-top: .24rem;font-size: .22rem;color: #b1b1b1;}
  .star-box-new{height:.42rem;margin-top: .08rem;}
  .star-box-new img{float:left;width: auto;height: .25rem;margin-right: .09rem;margin-top: .085rem;}
  .star-box-new span{float: left;margin-left:.13rem;font: .24rem/.42rem "Microsoft YaHei";color: #c6c6c6;}
  .list-box-info{margin-top:.25rem;font:.22rem/.4rem "Microsoft YaHei";color: #3d3d3d;}
  /*打赏内容*/
  .ds-box{height: .9rem;margin: .2rem .28rem 0;padding-left:.22rem;padding-right:.22rem;border-radius: .5rem;box-shadow: 0 0 0.25rem #f1f1f1;}
  .ds-box-img{float: left;width: .6rem;height: .6rem;margin-left:-.06rem;margin-top:.15rem;border-radius: 50%;object-fit: cover;}
  .ds-box-img:first-child{margin-left: 0;}
  .ds-box-img:nth-of-type(n+4){display: none;}
  .ds-box-num{float: left;margin-left: .22rem;font: .24rem/.9rem "Microsoft YaHei";color: #676767;}
  .ds-box-btn{width: .7rem;height: .7rem;text-align: center;margin-top: .1rem;font: .22rem/.7rem "Microsoft YaHei";color: #fff;border-radius: 50%;background: #ffc53f;}
  /*新增标题*/
  .list-tit-new{padding: .24rem .18rem 0;line-height: .4rem;font: bold .32rem/.4rem "Microsoft YaHei";color: #333;}
  .list-tit-new span{float: left;}
  .list-tit-new span:last-child{height:.28rem;padding:0 .06rem;margin-left: .08rem;margin-top:.06rem;border-radius: .3rem;background: #39affa;font: .18rem/.28rem "Microsoft YaHei";color: #fefefe;}
  /*视频列表*/
  .icon_gps{position:absolute;left:0;top:50%;width:.26rem;height:.24rem;transform:translateY(-40%);}
  .video-list{position:relative;width:100%;padding:.30rem .22rem;border-bottom:.01rem solid #f0f0f0;}
  .list-title{position:relative;font-size:.28rem;color:#ffc53f;padding-left:.42rem;}
  .video-list-info{float:left;width:50%;margin-top:.30rem;}
  .video-list-con{position:relative;display:block;width:3.20rem;height:3.20rem;margin:0 auto;background:url(https://jpjs.geeker.com.cn/frame/images/default_bg.png) no-repeat 50% ;overflow: hidden;}
  .video-list-con img.video-logo{width:100%;height:100%;background: none;}
  .video-list-con img.video-state{position:absolute;z-index:1;top:.13rem;right:.16rem;width: .27rem;height: auto;}
  .video-list-con.curr{-webkit-box-shadow: 0 0 .2rem #fec200;box-shadow: 0 0 .2rem #fec200; border: 2px solid #fec200;}
  .video-list-info .spot-name{display:block;width:3.20rem;height:.32rem;line-height:.32rem;margin:.10rem auto 0;font-size:.28rem;color:#666;}
  .video-list-info .spot-name.curr{color:#faaf39;}
  .video-list-info .spot-name .recommend-star{float:left;display:inline-block;width:.20rem;height:.20rem;margin-right:.10rem;margin-top:.05rem;}
  .video-list-con .icon_360{position: absolute;z-index: 1;top:50%;left:50%;width: auto;height: .52rem;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
  .video-see{position: absolute;right: -.34rem; top: .05rem; width: 1.2rem;height: .4rem;line-height: .4rem;font-size:.22rem;color:#fff;background-color: #f96900;text-align: center;transform: rotate(45deg);}
  /*底部购买按钮*/
  .bottom-btn-box{position:fixed;left:0;bottom:0;width:100%;height:1.14rem;background: #fff;z-index:1;box-shadow:0 0 .05rem #ddd;}
  .bottom-btn{ position: relative; display: block; height:1.14rem;line-height:1.14rem;color:#fff;background: #faaf39;z-index:1;text-align:center;font-size:.36rem;letter-spacing:.04rem;}
  .bottom-btn__yn{display: flex;align-items: center;border-top-left-radius: 0.6rem;border-bottom-left-radius: 0.6rem;margin-right: 0.2rem;}
  .bottom-btn__yn .lf{display: flex;align-items: center;height: 1rem;border-top-left-radius: 0.6rem;border-bottom-left-radius: 0.6rem; padding:0 0.3rem;color:#fff;background: #000;}
  .bottom-btn__yn .lf .price{margin-right: 0.2rem;}
  .bottom-btn__yn .lf .price span{font-size:0.28rem;}
  .bottom-btn__yn .lf .price b{margin-left: -0.06rem;font-size:0.6rem;font-weight: bold;}
  .bottom-btn__yn .lf .txt{font-size:0.24rem;}
  .bottom-btn__yn .rt{position:relative; flex:1;height: 1rem;border-top-right-radius: 0.6rem;border-bottom-right-radius: 0.6rem;text-align: center;line-height: 1rem;font-weight: 900;font-size: 0.36rem; background:#faaf39;}
  .bottom-btn__yn .rt:before{position: absolute;content: '';left: 0;top: 0;width: 0;height: 0;border-top: 1rem solid #000000;border-right: 0.2rem solid transparent;border-left: 0px solid transparent;}
  .video-listen{position:relative;width:1.50rem;height:1.14rem;}
  .video-listen span{position:absolute;top:.22rem;left:initial;right:16%;padding:.03rem .07rem;font-size:.18rem;color:#fff;background:#f96900;border-radius:.10rem;min-width:.24rem;text-align:center;}
  .btn-video-box.box1 .video-listen{position:absolute;left:0;top:50%;width:1.20rem;height:.45rem;-webkit-transform:translateY(-50%);transform:translateY(-50%);}
  .btn-video-box.box1 .video-listen span{position:absolute;top:-.20rem;left:initial;right:.12rem;padding:.03rem .10rem;font-size:.20rem;color:#fff;background:#faaf39;border-radius:.10rem;}
  .icon_play_num{position:absolute;top:50%;left:50%;width:.54rem;height:.50rem;margin:0 auto;transform:translate(-50%,-50%);}
  .bottom-btn-box.yn{height:1.4rem;}
  .yn .video-listen{width:1.14rem;height:1.4rem;}
  /*附近景区*/
  .list-tit{padding:.2rem 0;height:.36rem;color:#333;font-weight:bold;font-size:.32rem;line-height:.36rem}
  .list-tit span{float:left;margin-right:.12rem;width:.07rem;height:.36rem;background-color:#faaf39}
  .list-more{float:right;padding:0 .07rem;color:#555;font-size:.24rem}
  .conference-item-info-label img{width:.17rem;height:.26rem;vertical-align: middle;}
  .half .conference-item-parent{float: left;width:50%;}
  .half .conference-item-parent .conference-item{position: relative;margin-top: .2rem;background-color: #fff;border-radius: .15rem;}
  .half .conference-item-parent:nth-of-type(odd) .conference-item{padding-right:3%;}
  .half .conference-item-parent:nth-of-type(even) .conference-item{padding-left:3%;}
  .half .conference-item-parent .conference-item-img{position:relative;width:100%;height:2.7rem; border-radius: .08rem .08rem 0 0;overflow: hidden;}
  .half .conference-item-parent .conference-item-info{height:1rem; padding-left: .17rem; border-radius: 0 0 .08rem .08rem;box-shadow: 0 .06rem .1rem rgba(102,102,102,.1); }
  .half .conference-item-parent .conference-item-title{font-weight: bold;color: #333;font-size:.26rem;}
  .half .conference-item-parent .label-box{width: 100%;height:.48rem; line-height: .48rem; padding-top: .08rem; }
  .half .conference-item-parent .right-info{width: 100%;text-align: left;}
  .half .conference-item-parent .icon-time {font-size: .22rem;margin-left: .07rem;font-weight: bold;color: #666;}
  /*新增底部评论详情列表*/
  .comments-list{width:100%;padding:.36rem 0  .16rem .24rem; margin-bottom: 0; }
  .comments-list-top{width:100%;height:.88rem;padding:0 .22rem;margin-top: .4rem;border-bottom:1px solid #F0F0F0;}
  .comments-list-top .fl{font:bold .32rem/.88rem "Microsoft YaHei";color:#333;}
  .comments-list-top .fr{font:.28rem/.88rem "Microsoft YaHei";color:#666;}
  .comments-list-top .fr img{float:right;width:.29rem;height:.32rem;margin:.28rem 0 0 .16rem;}
  .comments-list .bottom-box{position:relative;width:100%;height:.88rem;background:#fff;}
  .select-more{height:.88rem;line-height:.88rem;font-size:.30rem;color:#faaf39;text-align:center;background: none;}
  .icon-reward-small{float:left;height:.26rem;line-height:.26rem;margin-top:-.03rem;margin-left:.05rem;padding:0 .10rem;font-size:.16rem;color:#fff;background:#f5681b;border-radius:.05rem;}
  .shz-text{margin-right:.24rem;color:#ff5400;font-size:.24rem;}


  /*新版大足石刻样式*/
  /* 顶部介绍 */
  .guide-box{padding: .32rem .24rem;background: #fff;}
  .guide-box .l{width: 1.84rem;height: 2.28rem;margin-right:.16rem;border-radius: .08rem;overflow: hidden;}
  .guide-box .l,.guide-box .l img{background-color: #f2f2f2;}
  .guide-box .r .name{font-size: .32rem;line-height: .46rem;color: #222;font-weight: bold;}
  .guide-box .r .sub{margin-top:.04rem;font-size: .24rem;line-height: .34rem;color: #666;font-weight: bold;}
  .guide-box .num-item{height: .34rem;line-height: .34rem;font-size: .24rem;color: #666;margin-top: .20rem;margin-right: .16rem;}
  .guide-box .num-item:last-child{margin-right: 0;}
  .guide-box .num-icon{width: .36rem;height: .34rem;margin-right: .07rem;}
  .guide-box .score-box{margin-top: .40rem;line-height:.32rem;font-size: .24rem;color:#666;}
  .guide-box .score-box img{float:left;width: .27rem;height: auto;margin-right: .09rem;margin-top: .035rem;}
  .guide-box .share-box{font-size: .28rem;color:#222;margin-right: .20rem;}
  .guide-box .share-box img{float:left;width: .33rem;height: .32rem;margin-right: .08rem;}
  .guide-box .bot-con{margin-top: .20rem;font-size: .24rem;line-height: .34rem;color: #444;}
  /* 切换 */
  .tab-box{margin-top: .24rem; height: .98rem;line-height: .98rem;border-bottom: 1px solid #e5e5e5;font-size: .30rem;color: #666;background: #fff;}
  .tab-box .flex {text-align: center;}
  .tab-box .flex div{position: relative;display: inline-block;}
  .tab-box .flex .txt{position:relative;z-index: 2;}
  .tab-box .flex.curr .txt{font-weight: bold;color: #000;}
  .tab-box .flex.curr .line{content: '';position: absolute;left: 0;right:0;bottom:.36rem;z-index: 1;height: .08rem;background: #ffc303;}
  /* 专辑介绍 */
  .voice-box{ }
  .voice-box .voice-list{margin-top: .30rem;}
  .voice-box .voice-list:first-child{margin-top: 0;}
  .voice-box .list-title{height: .85rem; font:bold .32rem/.85rem "Eras Medium ITC";color: #fff;background-color: #7d7e78;}
  .voice-box .list-title img{width: .24rem;height: .28rem;margin-right: .05rem;}
  .voice-box .list-title span{font-size: .24rem;color: #666;}
  .voice-box .spot-img{ position:relative; height: 4.2rem;padding-bottom: .15rem; }
  .voice-box .spot-station:nth-child(2n){background-color: #7d7e78;}
  .voice-box .spot-station:nth-child(2n+1){background-color: #896841;}
  .voice-box .spot-img .mask{top: unset;bottom: 0; height: 1rem;  }
  .voice-box .spot-station:nth-child(2n) .spot-img .mask{background: linear-gradient(to top, rgba(125,126,120,1), rgba(2125,126,120,0));}
  .voice-box .spot-station:nth-child(2n+1) .spot-img .mask{background: linear-gradient(to top, rgba(137,104,65,1), rgba(137,104,65,0));}
  .voice-box .voice-item{padding: 0 .3rem .4rem;}
  .voice-box .item-top{position:relative;float:left;margin-top: .3rem;margin-right: 4.4%;width: 47.8%;border-radius: .16rem;overflow: hidden;}
  .voice-box .item-top:nth-of-type(2n){margin-right: 0;}
  .voice-box .item-info{position:relative;height: 2.58rem;}
  .voice-box .list-video-mask{position: absolute;z-index:1;top:0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,.1);pointer-events: none;}
  .voice-box .icon_360{position: absolute;z-index: 1;top:.15rem;left:.18rem;width: auto;height: .35rem;pointer-events: none;}
  .voice-box .video-label{position: absolute;left:0; bottom: 0;z-index: 1; height: .4rem;padding:0 .12rem;line-height: .4rem;font-size:.22rem;color:#fff;background-color: #f96900;text-align: center;border-radius: 0 .15rem 0 0;pointer-events: none;}
  .voice-box .video-state{position: absolute;left:50%; top: 50%;z-index: 1; width: .72rem;height: .72rem;transform: translate(-50%,-50%); pointer-events: none;}
  .voice-box .item-name{height: .7rem;font: bold .3rem/.7rem 'Eras Medium ITC';color: #333;padding: 0 .15rem;background-color: #fff;}
  .voice-box .item-top.curr .item-name{color: #f96900;}
  /* 评价打赏 */
  .voice-pjds{padding: 0 .24rem;background: #fff;}
  .voice-pjds .voice-ds{padding: .40rem 0;border-bottom: 1px solid #e3e3e3;}
  .voice-pjds .ds-btn{width: 1.24rem;height: .56rem;line-height: .56rem;text-align: center;font-size: .28rem;color: #000;background: #fec200;border-radius: .28rem;margin-top: .02rem;}
  .voice-pjds .ds-img img{float: left;width: .60rem;height: .60rem;margin-left: -.06rem;border-radius: 50%;}
  .voice-pjds .ds-img img:first-child{margin-left: 0;}
  .voice-pjds .ds-num {float: left;margin-left: .22rem;font-size: .24rem;color: #666;line-height: .60rem;}
  .voice-pj-top{font-size: .28rem;color: #49351e;padding-top: .26rem;padding-bottom: .62rem;}
  .voice-pj-top .star{margin-left: .18rem;font-size: .24rem;color: #666;}
  .voice-pj-top .star img{float: left;width: .27rem;height: .26rem;margin-top: .02rem;margin-right: .09rem;}
  .voice-pj-top .pj-btn{font-size: .28rem;color: #333;}
  .voice-pj-top .pj-btn img{float:right;width: .29rem;height: .32rem;margin-left: .10rem;margin-top: .04rem;}
  .pj-item{margin-top: .14rem;padding-top: .1rem;}
  .pj-item:first-child{margin-top: 0;}
  .pj-item .head-img{width: .64rem;height: .64rem;margin-right:.15rem;border-radius: 50%;overflow: hidden;}
  .pj-item .name{font-size: .28rem;color: #666;line-height: .38rem;}
  .pj-item .star{height:.26rem;margin-top: .07rem;}
  .pj-item .star img{float:left;width: .16rem;height: .16rem;margin-right: .07rem;margin-top: .05rem;}
  .pj-item .icon-reward-small{height:.26rem;line-height:.26rem;margin-top:-.03rem;margin-left:.05rem;padding:0 .10rem;font-size:.16rem;color:#fff;background:#f5681b;border-radius:.05rem;}
  .pj-item .zan{height: .32rem;line-height: .32rem;color: #796042;font-size: .20rem;margin-top: .12rem;}
  .pj-item .zan .fl{line-height: .36rem;}
  .pj-item .zan img{float: right;width: .31rem;height: .3rem;margin-left: .06rem;}
  .pj-item .pj-txt{margin-top:.16rem;font-size: .28rem;line-height: .42rem;color: #333;}
  .pj-item .pj-time{padding: 0.1rem 0 0.15rem; font-size: .22rem;line-height: .32rem;color: #999;}
  .pj-item .pj-img img{width: 1.00rem;height: 1.00rem;margin-right: .20rem; margin-top: .15rem;}
  .voice-pjds .more-pj{font-size: .28rem;margin-top: .35rem;padding: .28rem 0;border-top: 1px solid #e5e5e5;color: #333;text-align: center;}
  .voice-pjds .more-pj img{color: #f99d0b;}

  .main-scroll-view2 .half .conference-item-parent .conference-item{background: none;}
  .main-scroll-view2 .half .conference-item-parent .conference-item-img,.main-scroll-view2 .half .conference-item-parent .conference-item-info{background-color: #fff}



  /*视频弹窗*/
  .video-alert{position: fixed;z-index:999;left:0;top:0;width: 100vw;height: 100vh;background: rgba(0,0,0,1);}
  .video-close{position: absolute; z-index: 5; top: 10px; right: 20px; width: 15px; height: 15px; padding: 5px; background: #fff; border-radius: 50%;}
  .video-tip{position: absolute; z-index: 999; top: 10px; right: 0; width: 78px; height: 36px; line-height: 36px; padding-left: 15px; font-size: 15px; letter-spacing: 2px; color: #333; background: #fff; border-radius: 50px 0 0 50px; }
  .video-tip > img{ width: 30px; height: 30px; vertical-align: middle;  float: right; margin-top: 3px; margin-right: 5px; }
  .video-alert-mask{position:absolute;left:0;top:0;z-index: 2;width: 100%;}
  .video-alert-mask img{display: block;width: 63.6%;height: auto;margin: 18.5% auto 0;}
  .video-alert-btn{display: block;width: 1.62rem;height: .59rem;margin:1.7rem auto 0;text-align: center;font: bold .26rem/.59rem "Microsoft YaHei";color: #fff;border:1px dashed #fff;border-radius: .2rem;}
  .video-vricon{position: absolute; z-index: 999; bottom: 30vh; right: .3rem;width:1.14rem;height: 1.16rem;background: url(../../assets/icon_vr.png) no-repeat center;background-size: 100% 100%;}
  .video-vricon img{position: absolute; z-index: 1; top: -.25rem; right: -.1rem;width: .36rem;height: .36rem;}

  /*分享按钮*/
  .list-share{ position:absolute;bottom: .2rem;right: .28rem;z-index:9; width: .41rem; height: .72rem; }
  .list-share img{ width: 100%; height: auto; }

  /*返回上一页按钮*/
  .link-btn{position: fixed;z-index:2;right:0;bottom:4rem;height: .6rem;padding:0 .28rem;font: .28rem/.6rem "Microsoft YaHei";color:#fff;border-radius: .3rem 0 0 .3rem;background: rgba(0,0,0,.7);}


  /*VR点位*/
  .vr-point{position: absolute; top: -500px; left: -500px;z-index:2; transform: scale(.5)}
  .vr-dot{ position: absolute; top: -.35rem; left: -.35rem; width: .7rem; height: .7rem; border-radius: 50%; background-size: 100%; box-shadow: 0 2px 4px rgba(0,0,0,.2); transition: all .3s ease 0s; transform-origin: center center}
  .vr-dot:after { content: ""; position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%) scale(1.3); width: 1.5rem; height: 1.5rem;
     -webkit-animation: audioShake-sprites-animation 1.375s steps(33) 0s infinite normal; animation: audioShake-sprites-animation 1.375s steps(33) 0s infinite normal }
  .vr-dot:before { content: ""; width: 2.5rem; height: 2.5rem; display: inline-block; position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%) }
  @-webkit-keyframes audioShake-sprites-animation {  0% {  background-position: 0 0  }  to {  background-position: -49.5rem 0  }  }
  @keyframes audioShake-sprites-animation { 0% {  background-position: 0 0  } to { background-position: -49.5rem 0  } }
  .vr-txt{position: absolute; top: -90px; left: -300px; width: 600px; font-size: 30px; text-align: center;font-weight: bold;}
  .vr-txt.colr1{color:#fff;}
  .vr-txt.colr2{color:#ffc303;}
  .vr-txt.colr3{color:#fff100;}
  .vr-dot.colr1{ background-color: #fff;}
  .vr-dot.colr2{ background-color: #ffc303;}
  .vr-dot.colr3{ background-color: #fff100;}
  .vr-dot.colr1:after{ background-image: url(../../assets/vr-dot1.png); background-size: 51rem 1.5rem;background-repeat: no-repeat;}
  .vr-dot.colr2:after{ background-image: url(../../assets/vr-dot.png); background-size: 51rem 1.5rem;background-repeat: no-repeat;}
  .vr-dot.colr3:after{background-image: url(../../assets/vr-dot3.png); background-size: 51rem 1.5rem;background-repeat: no-repeat;}



  .alert-info .alert-con {position: absolute;left: 50%;top: 46%;width: 80%;height: 66vh;;background: #fff;border-radius: .2rem;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);color: #333;}
  .alert-info .tit{position:absolute;top:0;left:0;width:100%;height:.86rem;padding-top:.4rem;font: bold .32rem/.46rem "Microsoft YaHei";background: #fff;border-radius: .2rem .2rem 0 0;}
  .alert-info .info-scroll{position:absolute;top:.86rem;left: 0;width: 100%;height: calc(100% - .86rem);padding: .16rem .24rem .24rem;overflow-y: scroll;overflow-x: hidden;}
  .alert-info .txt{font: .28rem/.42rem "Microsoft YaHei";text-indent: .56rem;text-align: justify;}
  .alert-info .info-scroll img,.alert-info .info-scroll .txt img{display: block;width: auto;max-width:100%;height: auto;margin: .24rem auto;text-indent: 0;}
  .alert-info .close{position: absolute;top:-.74rem;left: 50%;width: .54rem;height: .54rem;margin-left: -.27rem;}
</style>

<style>
  /*全景图片加载*/
  .psv-container .psv-loader{ width: 64px; height: 64px; }
  .psv-container .psv-loader-text{ display: none; }

  /*VR播放*/
  #videoFullScreen{ display: none!important; }
  #panoDesk{ position: absolute; width: 100%; height: 100%; left: 0; top: 0; overflow: hidden; }
  .toolBar{ position: absolute; bottom: 65px;z-index: 0; width: 100%; height: 62px; text-align: center; overflow-x: auto; -webkit-transition: all ease .3s; -moz-transition: all ease .3s; transition: all ease .3s;  }
  .toolTxt{ position: absolute; left: 10%; bottom: 130px;z-index: 0; width: 80%; text-align: center; font-size: .34rem; letter-spacing: 2px;font-weight: bolder; font-family: 'simsu'; color: #fff; text-shadow: -1px 1px 0 #000, 1px 1px 0 #000, 1px -1px 0 #000,-1px -1px 0 #000; }
  .toolBar.toolBar1 { height: 0; overflow: hidden; }
  .toolBox { height: 62px; overflow-y: hidden; }
  .toolBtn { position: relative; width: 108px; height: 60px; margin-right: 10px; float: left; border: 1px solid #fff; overflow: hidden; }
  .toolBtn > img{ width: 100%; height: 100%; object-fit: cover;background: url(https://jpjs.geeker.com.cn/frame/images/default_bg.png) no-repeat 50%; }
  .toolBtn-tit{ position: absolute; left: 0; bottom: 0; width: 100%; background-color: rgba(0,0,0,.5); height: 16px; line-height: 16px; color: #fff; font-size: 12px; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; overflow: hidden;}
  .toolBtn-tit > p{ display: inline-block; width: 95%; padding-right: 5%; }
  .toolBtn.curr{ border: 1px solid #faaf39; }
  .toolBtn.curr .toolBtn-tit{ color: #faaf39; }
  .toolBtn .video-see{position: absolute;right: -.34rem; top: .05rem; width: 1.1rem; height: .34rem; line-height: .34rem; font-size: .2rem;color:#fff;background-color: #f96900;text-align: center;transform: rotate(45deg);}
  /*.toolBtn.curr .toolBtn-tit > .p1 { -webkit-animation: move1 8s linear infinite; animation: move1 8s linear infinite; }*/
  /*.toolBtn.curr .toolBtn-tit > .p2 { -webkit-animation: move2 8s linear infinite; animation: move2 8s linear infinite; -webkit-animation-delay: 4s; animation-delay: 4s; }*/
  @-webkit-keyframes move1 {0% { -webkit-transform: translateX(100%); transform: translateX(100%) }to { -webkit-transform: translateX(-100%); transform: translateX(-100%) }}
  @keyframes move1 {0% { -webkit-transform: translateX(100%); transform: translateX(100%) }to { -webkit-transform: translateX(-100%); transform: translateX(-100%) }}
  @-webkit-keyframes move2 {0% { -webkit-transform: translateX(0); transform: translateX(0)  }to { -webkit-transform: translateX(-200%); transform: translateX(-200%) }}
  @keyframes move2 {0% { -webkit-transform: translateX(0); transform: translateX(0) }to { -webkit-transform: translateX(-200%); transform: translateX(-200%) }}

  #panoDesk div[name="SceneViewer"]{ z-index: auto!important;}

  #vrCont .info-scroll img,#vrCont .info-scroll .txt img{display: block;width: auto;max-width:100%;height: auto;margin: .24rem auto;text-indent: 0;}
</style>




// WEBPACK FOOTER //
// src/page/video-vr/video-vr.vue